import { useCanEditEmployee } from '@/services/settings/useCanEditEmployee';
import { FC } from 'react';
import { FiLock } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { TSTitleCard } from '../../../../components/shared/card/Card';
import { ReadEmployee } from '../../../../services/gql/graphql.generated';
import { strings } from '../../../../services/translation/strings';

interface PermissionsCardProps {
  employee: ReadEmployee;
}

export const PermissionsCard: FC<PermissionsCardProps> = ({ employee }) => {
  const canEdit = useCanEditEmployee();
  const navigate = useNavigate();
  const onEditClick = () => {
    navigate(`/team-member/${employee.identityId}/edit-permissions`);
  };

  return (
    <TSTitleCard
      className="bg-white"
      title={strings.timeshift.teamMember.permissions.cardTitle}
      icon={FiLock}
      primaryAction={
        canEdit
          ? {
              label: strings.timeshift.teamMember.permissions.edit,
              onClick: onEditClick
            }
          : undefined
      }
    >
      <div className="flex flex-col gap-4 ">
        <div className="flex flex-col gap-2">
          <span className="font-semibold">{strings.timeshift.teamMember.permissions.role}</span>
          <span>{employee.role}</span>
        </div>
      </div>
    </TSTitleCard>
  );
};
